const selectAll = 'Select all that apply';
const amount = 'Amount:';
const amountOther = 'Other Amount:';
const bankOther = 'Other Bank:';
const howMuch = 'How much:';
const whenYouNeed = 'When:';
const accessType = 'Access:';
const borrow = 'Borrow?';
const currentAccount_amount = 'Amount in account with our bank:';
const currentAccount_otherBankAmount = 'Funds outside of our bank:';
const currentAccount_otherBankName = 'Other bank name:';
const amountToBorrow = 'How much do you need?';
const loanTiming = 'When do you need the money?';
const loanTimingOptions = {now: 'Immediate', three: '3 months', six: '6 months', twelve:'1 year', more:'Over a Year'};
const loanAccess = 'How will you access your money?';
const wantsToBorrow = 'Do you wish to borrow?';
const upFront = 'All at once';
const overTime = 'Over time';
const yes = 'Yes';
const no = 'No';

export default {
    /**
     * ============================
     * PATH / PAGE MESSAGES
     * ============================
     */

    'sidebar.entry.text': 'Welcome to Bank, help us get to know you.',
    'sidebar.consumer.text': 'Help us understand your banking needs.',
    'sidebar.personalized.text': 'Let\'s discuss more about your banking preferences.',
    'sidebar.exit.text': 'Just a few more questions to complete your profile.',

    /**
     * ============================
     * QUESTION MESSAGES
     * ============================
     */
    'reasonForVisit': 'What is the purpose of your visit today?',
    'reasonForVisit.tooltip': 'Help us understand your needs today',
    'reasonForVisit.goals': 'Work on Financial Goals',
    'reasonForVisit.savings': 'Establish Savings',
    'reasonForVisit.banking': 'Open New Accounts',
    'reasonForVisit.other': 'Other',

    'surveyPage.meta.title.entry': 'Entry Path Questions',
    'isCustomer': 'What existing relationships do you have with our bank?',
    'isCustomer.subtext': selectAll,
    'isCustomer.personal': 'Personal Banking',
    'isCustomer.business': 'Business Banking',
    'isCustomer.none': 'None',
    'isCustomer.none.tooltip': 'You are not a customer?!?',

    'lifeStage': 'Which of following life stages apply to you:',
    'lifeStage.tooltip': 'Tell us about your lifestyle.',
    'lifeStage.subtext': selectAll,
    'lifeStage.student': 'Student',
    'lifeStage.retired': 'Retired',
    'lifeStage.veteran': 'Veteran',
    'lifeStage.youngFamily': 'Starting a family',
    'lifeStage.matureFamily': 'Kid(s) going to college',
    'lifeStage.youngProfessional': 'Just graduated / young professional',
    'lifeStage.matureProfessional': 'Growing in career',
    'lifeStage.none': 'None',

    'lifeSituations': 'Do you need assistance with any of the following situations:',
    'lifeSituations.uncertainty': 'Help with financial uncertainty',
    'lifeSituations.dayToDay': 'Help with day-to-day finances',
    'lifeSituations.sendMoney': 'Sending money to relatives',
    'lifeSituations.volatileIncome': 'Managing income volatility',
    'lifeSituations.incomeSources': 'Finding additional sources of income',
    'lifeSituations.financialRecovery': 'Recover from financial hardship(s)',
    'lifeSituations.none': 'None',

    'technologyUse': 'How comfortable are you with technology?',
    'technologyUse.1': 'I avoid technology',
    'technologyUse.2': 'A little bit',
    'technologyUse.3': 'Moderate',
    'technologyUse.4': 'Very comfortable',
    'technologyUse.5': 'Power user',

    'goalsQuestionGroup': 'Preparing for your goals is critical for achieving financial success.  Tell us about your financial goals:',
    'goalsQuestionGroup.subtext': 'Add your financial goals below.',
    'goalTypes.cardBuilder.removeCard': 'Remove',
    'goalTypes.cardBuilder.editCard': 'Edit',
    'goalTypes.cardBuilder.addCard': 'Add Goal',
    'goalTypes.cardBuilder.cancelEdit': 'Cancel',
    'goalTypes.cardBuilder.saveCard': 'Save',
    'goalTypes.cardBuilder.modal.title': 'Tell us about your goal:',
    'goalTypes': 'Select your goal:',
    'goalTypes.vehicleGoal': 'Vehicle',
    'goalTypes.educationGoal': 'Education',
    'goalTypes.healthcareGoal': 'Healthcare',
    'goalTypes.homeGoal': 'Buy a home',
    'goalTypes.homeImprovementGoal': 'Home improvement',
    'goalTypes.secondHomeGoal': 'Buy a second home / investment property',
    'goalTypes.retirementGoal': 'Retirement / Estate planning',
    'goalTypes.majorPurchaseGoal': 'Major purchase',
    'goalTypes.lifeEventGoal': 'Major life event',
    'goalTypes.rainyDayGoal': 'Rainy day',
    'goalTypes.debtConsolidationGoal': 'Consolidate Debt',
    'goalTypes.refinanceHomeGoal': 'Refinance home',
    'goalTypes.otherGoal': 'Other',

    'otherGoal.cardBuilder.title': 'Other',
    'otherGoalAmount': 'How much do you need?',
    'details.otherGoalAmount': `Goals: Other | ${ amountToBorrow }`,
    'otherGoalTiming': 'When do you need the money?',
    'otherGoalTiming.0': loanTimingOptions.now,
    'otherGoalTiming.3': loanTimingOptions.three,
    'otherGoalTiming.6': loanTimingOptions.six,
    'otherGoalTiming.12': loanTimingOptions.twelve,
    'otherGoalTiming.24': loanTimingOptions.more,
    'details.otherGoalTiming': `Goals: Other | ${ loanTiming }`,
    'otherGoalAccess': 'When will you access your money?',
    'otherGoalAccess.upFront': upFront,
    'otherGoalAccess.overTime': overTime,
    'details.otherGoalAccess': `Goals: Other | ${ loanAccess }`,
    'otherGoalWantsToBorrow': 'Do you wish to borrow?',
    'otherGoalWantsToBorrow.true': yes,
    'otherGoalWantsToBorrow.false': no,
    'details.otherGoalWantsToBorrow': `Goals: Other | ${ wantsToBorrow }`,
    'otherGoalAmount.cardBuilder.answerLabel': howMuch,
    'otherGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'otherGoalAccess.cardBuilder.answerLabel': accessType,
    'otherGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'refinanceHomeGoal.cardBuilder.title': 'Refinance Home',
    'refinanceHomeGoalAmount': 'How much do you need?',
    'details.refinanceHomeGoalAmount': `Goals: Refinance Home | ${ amountToBorrow }`,
    'refinanceHomeGoalTiming': 'When are you looking to refinance your home?',
    'refinanceHomeGoalTiming.0': loanTimingOptions.now,
    'refinanceHomeGoalTiming.3': loanTimingOptions.three,
    'refinanceHomeGoalTiming.6': loanTimingOptions.six,
    'refinanceHomeGoalTiming.12': loanTimingOptions.twelve,
    'refinanceHomeGoalTiming.24': loanTimingOptions.more,
    'details.refinanceHomeGoalTiming': `Goals: Refinance Home | ${ loanTiming }`,
    'refinanceHomeGoalAmount.cardBuilder.answerLabel': howMuch,
    'refinanceHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'refinanceHomeGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'debtConsolidationGoal.cardBuilder.title': 'Debt Consolidation',
    'debtConsolidationGoalAmount': 'How much do you need?',
    'details.debtConsolidationGoalAmount': `Goals: Debt Consolidation | ${ amountToBorrow }`,
    'details.debtConsolidationGoalTiming': `Goals: Debt Consolidation | ${ loanTiming }`,
    'debtConsolidationGoalAccess': 'When will you access your money?',
    'debtConsolidationGoalAccess.upFront': upFront,
    'debtConsolidationGoalAccess.overTime': overTime,
    'details.debtConsolidationGoalAccess': `Goals: Debt Consolidation | ${ loanAccess }`,
    'debtConsolidationGoalWantsToBorrow': 'Do you wish to borrow?',
    'debtConsolidationGoalWantsToBorrow.true': yes,
    'debtConsolidationGoalWantsToBorrow.false': no,
    'details.debtConsolidationGoalWantsToBorrow': `Goals: Debt Consolidation | ${ wantsToBorrow }`,
    'debtConsolidationGoalAmount.cardBuilder.answerLabel': howMuch,
    'debtConsolidationGoalAccess.cardBuilder.answerLabel': accessType,
    'debtConsolidationGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'rainyDayGoal.cardBuilder.title': 'Rainy Day',
    'rainyDayGoalAmount': 'How much do you need?',
    'details.rainyDayGoalAmount': `Goals: Rainy Day | ${ amountToBorrow }`,
    'rainyDayGoalTiming': 'When do you need the money?',
    'rainyDayGoalTiming.0': loanTimingOptions.now,
    'rainyDayGoalTiming.3': loanTimingOptions.three,
    'rainyDayGoalTiming.6': loanTimingOptions.six,
    'rainyDayGoalTiming.12': loanTimingOptions.twelve,
    'rainyDayGoalTiming.24': loanTimingOptions.more,
    'details.rainyDayGoalTiming': `Goals: Rainy Day | ${ loanTiming }`,
    'rainyDayGoalAccess': 'When will you access your money?',
    'rainyDayGoalAccess.upFront': upFront,
    'rainyDayGoalAccess.overTime': overTime,
    'details.rainyDayGoalAccess': `Goals: Rainy Day | ${ loanAccess }`,
    'rainyDayGoalWantsToBorrow': 'Do you wish to borrow?',
    'rainyDayGoalWantsToBorrow.true': yes,
    'rainyDayGoalWantsToBorrow.false': no,
    'details.rainyDayGoalWantsToBorrow': `Goals: Rainy Day | ${ wantsToBorrow }`,
    'rainyDayGoalAmount.cardBuilder.answerLabel': howMuch,
    'rainyDayGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'rainyDayGoalAccess.cardBuilder.answerLabel': accessType,
    'rainyDayGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'vehicleGoal.cardBuilder.title': 'Auto',
    'vehicleGoalAmount': 'How much do you need?',
    'details.vehicleGoalAmount': `Goals: Auto | ${ amountToBorrow }`,
    'vehicleGoalAccess': 'When will you access your money?',
    'vehicleGoalAccess.upFront': upFront,
    'vehicleGoalAccess.overTime': overTime,
    'vehicleGoalTiming': 'When do you plan to buy your car?',
    'vehicleGoalTiming.0': loanTimingOptions.now,
    'vehicleGoalTiming.3': loanTimingOptions.three,
    'vehicleGoalTiming.6': loanTimingOptions.six,
    'vehicleGoalTiming.12': loanTimingOptions.twelve,
    'vehicleGoalTiming.24': loanTimingOptions.more,
    'details.vehicleGoalTiming': `Goals: Vehicle | ${ loanTiming }`,
    'details.vehicleGoalAccess': `Goals: Auto | ${ loanAccess }`,
    'vehicleGoalWantsToBorrow': 'Do you wish to borrow?',
    'vehicleGoalWantsToBorrow.true': yes,
    'vehicleGoalWantsToBorrow.false': no,
    'details.vehicleGoalWantsToBorrow': `Goals: Auto | ${ wantsToBorrow }`,
    'vehicleGoalAmount.cardBuilder.answerLabel': howMuch,
    'vehicleGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'vehicleGoalAccess.cardBuilder.answerLabel': accessType,
    'vehicleGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'educationGoal.cardBuilder.title': 'Education',
    'educationGoalAmount': 'How much do you need?',
    'details.educationGoalAmount': `Goals: Education | ${ amountToBorrow }`,
    'educationGoalTiming': 'When do you need the money?',
    'educationGoalTiming.0': loanTimingOptions.now,
    'educationGoalTiming.3': loanTimingOptions.three,
    'educationGoalTiming.6': loanTimingOptions.six,
    'educationGoalTiming.12': loanTimingOptions.twelve,
    'educationGoalTiming.24': loanTimingOptions.more,
    'details.educationGoalTiming': `Goals: Education | ${ loanTiming }`,
    'educationGoalAccess': 'When will you access your money?',
    'educationGoalAccess.upFront': upFront,
    'educationGoalAccess.overTime': overTime,
    'details.educationGoalAccess': `Goals: Education | ${ loanAccess }`,
    'educationGoalWantsToBorrow': 'Do you wish to borrow?',
    'educationGoalWantsToBorrow.true': yes,
    'educationGoalWantsToBorrow.false': no,
    'details.educationGoalWantsToBorrow': `Goals: Education | ${ wantsToBorrow }`,
    'educationGoalAmount.cardBuilder.answerLabel': howMuch,
    'educationGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'educationGoalAccess.cardBuilder.answerLabel': accessType,
    'educationGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'healthcareGoal.cardBuilder.title': 'Health Care',
    'healthcareGoalAmount': 'How much do you need?',
    'details.healthcareGoalAmount': `Goals: Health Care | ${ amountToBorrow }`,
    'healthcareGoalTiming': 'When do you need the money?',
    'healthcareGoalTiming.0': loanTimingOptions.now,
    'healthcareGoalTiming.3': loanTimingOptions.three,
    'healthcareGoalTiming.6': loanTimingOptions.six,
    'healthcareGoalTiming.12': loanTimingOptions.twelve,
    'healthcareGoalTiming.24': loanTimingOptions.more,
    'details.healthcareGoalTiming': `Goals: Health Care | ${ loanTiming }`,
    'healthcareGoalAccess': 'When will you access your money?',
    'healthcareGoalAccess.upFront': upFront,
    'healthcareGoalAccess.overTime': overTime,
    'details.healthcareGoalAccess': `Goals: Health Care | ${ loanAccess }`,
    'healthcareGoalWantsToBorrow': 'Do you wish to borrow?',
    'healthcareGoalWantsToBorrow.true': yes,
    'healthcareGoalWantsToBorrow.false': no,
    'details.healthcareGoalWantsToBorrow': `Goals: Health Care | ${ wantsToBorrow }`,
    'healthcareGoalAmount.cardBuilder.answerLabel': howMuch,
    'healthcareGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'healthcareGoalAccess.cardBuilder.answerLabel': accessType,
    'healthcareGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'homeGoal.cardBuilder.title': 'Home',
    'homeGoalAmount': 'How much do you need?',
    'details.homeGoalAmount': `Goals: Home | ${ amountToBorrow }`,
    'homeGoalTiming': 'When do you need the money?',
    'homeGoalTiming.0': loanTimingOptions.now,
    'homeGoalTiming.3': loanTimingOptions.three,
    'homeGoalTiming.6': loanTimingOptions.six,
    'homeGoalTiming.12': loanTimingOptions.twelve,
    'homeGoalTiming.24': loanTimingOptions.more,
    'details.homeGoalTiming': `Goals: Home | ${ loanTiming }`,
    'homeGoalAccess': 'When will you access your money?',
    'homeGoalAccess.upFront': upFront,
    'homeGoalAccess.overTime': overTime,
    'details.homeGoalAccess': `Goals: Home | ${ loanAccess }`,
    'homeGoalWantsToBorrow': 'Do you wish to borrow?',
    'homeGoalWantsToBorrow.true': yes,
    'homeGoalWantsToBorrow.false': no,
    'details.homeGoalWantsToBorrow': `Goals: Home | ${ wantsToBorrow }`,
    'homeGoalAmount.cardBuilder.answerLabel': howMuch,
    'homeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'homeGoalAccess.cardBuilder.answerLabel': accessType,
    'homeGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'homeImprovementGoal.cardBuilder.title': 'Home Improvement',
    'homeImprovementGoalAmount': 'How much do you need?',
    'details.homeImprovementGoalAmount': `Goals: Home Improvement | ${ amountToBorrow }`,
    'homeImprovementGoalTiming': 'When do you need the money?',
    'homeImprovementGoalTiming.0': loanTimingOptions.now,
    'homeImprovementGoalTiming.3': loanTimingOptions.three,
    'homeImprovementGoalTiming.6': loanTimingOptions.six,
    'homeImprovementGoalTiming.12': loanTimingOptions.twelve,
    'homeImprovementGoalTiming.24': loanTimingOptions.more,
    'details.homeImprovementGoalTiming': `Goals: Home Improvement | ${ loanTiming }`,
    'homeImprovementGoalAccess': 'When will you access your money?',
    'homeImprovementGoalAccess.upFront': upFront,
    'homeImprovementGoalAccess.overTime': overTime,
    'details.homeImprovementGoalAccess': `Goals: Home Improvement | ${ loanAccess }`,
    'homeImprovementGoalWantsToBorrow': 'Do you wish to borrow?',
    'homeImprovementGoalWantsToBorrow.true': yes,
    'homeImprovementGoalWantsToBorrow.false': no,
    'details.homeImprovementGoalWantsToBorrow': `Goals: Home Improvement | ${ wantsToBorrow }`,
    'homeImprovementGoalAmount.cardBuilder.answerLabel': howMuch,
    'homeImprovementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'homeImprovementGoalAccess.cardBuilder.answerLabel': accessType,
    'homeImprovementGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'secondHomeGoal.cardBuilder.title': 'Second Home / Investment Prop.',
    'secondHomeGoalAmount': 'How much do you need?',
    'details.secondHomeGoalAmount': `Goals: Second Home | ${ amountToBorrow }`,
    'secondHomeGoalTiming': 'When do you need the money?',
    'secondHomeGoalTiming.0': loanTimingOptions.now,
    'secondHomeGoalTiming.3': loanTimingOptions.three,
    'secondHomeGoalTiming.6': loanTimingOptions.six,
    'secondHomeGoalTiming.12': loanTimingOptions.twelve,
    'secondHomeGoalTiming.24': loanTimingOptions.more,
    'details.secondHomeGoalTiming': `Goals: Second Home | ${ loanTiming }`,
    'secondHomeGoalAccess': 'When will you access your money?',
    'secondHomeGoalAccess.upFront': upFront,
    'secondHomeGoalAccess.overTime': overTime,
    'details.secondHomeGoalAccess': `Goals: Second Home | ${ loanAccess }`,
    'secondHomeGoalWantsToBorrow': 'Do you wish to borrow?',
    'secondHomeGoalWantsToBorrow.true': yes,
    'secondHomeGoalWantsToBorrow.false': no,
    'details.secondHomeGoalWantsToBorrow': `Goals: Second Home | ${ wantsToBorrow }`,
    'secondHomeGoalAmount.cardBuilder.answerLabel': howMuch,
    'secondHomeGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'secondHomeGoalAccess.cardBuilder.answerLabel': accessType,
    'secondHomeGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'retirementGoal.cardBuilder.title': 'Retirement',
    'retirementGoalAmount': 'How much do you need?',
    'details.retirementGoalAmount': `Goals: Retirement | ${ amountToBorrow }`,
    'retirementGoalTiming': 'When do you plan to retire?',
    'retirementGoalTiming.1': '0-5 years',
    'retirementGoalTiming.5': '5-10 years',
    'retirementGoalTiming.10': '10-20 years',
    'retirementGoalTiming.20': 'Over 20 years',
    'details.retirementGoalTiming': 'Goals: Retirement | When do you plan to retire?',
    'retirementGoalSavedToDate': 'How much have you saved so far?',
    'details.retirementGoalSavedToDate': 'Goals: Retirement | How much have you saved so far?',
    'retirementGoalAmount.cardBuilder.answerLabel': howMuch,
    'retirementGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'retirementGoalSavedToDate.cardBuilder.answerLabel': 'Saved:',

    'majorPurchaseGoal.cardBuilder.title': 'Major Purchase',
    'majorPurchaseGoalAmount': 'How much do you need?',
    'details.majorPurchaseGoalAmount': `Goals: Major Purchase | ${ amountToBorrow }`,
    'majorPurchaseGoalTiming': 'When do you need the money?',
    'majorPurchaseGoalTiming.0': loanTimingOptions.now,
    'majorPurchaseGoalTiming.3': loanTimingOptions.three,
    'majorPurchaseGoalTiming.6': loanTimingOptions.six,
    'majorPurchaseGoalTiming.12': loanTimingOptions.twelve,
    'majorPurchaseGoalTiming.24': loanTimingOptions.more,
    'details.majorPurchaseGoalTiming': `Goals: Major Purchase | ${ loanTiming }`,
    'majorPurchaseGoalAccess': 'When will you access your money?',
    'majorPurchaseGoalAccess.upFront': upFront,
    'majorPurchaseGoalAccess.overTime': overTime,
    'details.majorPurchaseGoalAccess': `Goals: Major Purchase | ${ loanAccess }`,
    'majorPurchaseGoalWantsToBorrow': 'Do you wish to borrow?',
    'majorPurchaseGoalWantsToBorrow.true': yes,
    'majorPurchaseGoalWantsToBorrow.false': no,
    'details.majorPurchaseGoalWantsToBorrow': `Goals: Major Purchase | ${ wantsToBorrow }`,
    'majorPurchaseGoalAmount.cardBuilder.answerLabel': howMuch,
    'majorPurchaseGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'majorPurchaseGoalAccess.cardBuilder.answerLabel': accessType,
    'majorPurchaseGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'lifeEventGoal.cardBuilder.title': 'Life Event',
    'lifeEventGoalAmount': 'How much do you need?',
    'details.lifeEventGoalAmount': `Goals: Life Event | ${ amountToBorrow }`,
    'lifeEventGoalTiming': 'When do you need the money?',
    'lifeEventGoalTiming.0': loanTimingOptions.now,
    'lifeEventGoalTiming.3': loanTimingOptions.three,
    'lifeEventGoalTiming.6': loanTimingOptions.six,
    'lifeEventGoalTiming.12': loanTimingOptions.twelve,
    'lifeEventGoalTiming.24': loanTimingOptions.more,
    'details.lifeEventGoalTiming': `Goals: Life Event | ${ loanTiming }`,
    'lifeEventGoalAccess': 'When will you access your money?',
    'lifeEventGoalAccess.upFront': upFront,
    'lifeEventGoalAccess.overTime': overTime,
    'details.lifeEventGoalAccess': `Goals: Life Event | ${ loanAccess }`,
    'lifeEventGoalWantsToBorrow': 'Do you wish to borrow?',
    'lifeEventGoalWantsToBorrow.true': yes,
    'lifeEventGoalWantsToBorrow.false': no,
    'details.lifeEventGoalWantsToBorrow': `Goals: Life Event | ${ wantsToBorrow }`,
    'lifeEventGoalAmount.cardBuilder.answerLabel': howMuch,
    'lifeEventGoalTiming.cardBuilder.answerLabel': whenYouNeed,
    'lifeEventGoalAccess.cardBuilder.answerLabel': accessType,
    'lifeEventGoalWantsToBorrow.cardBuilder.answerLabel': borrow,

    'reviewEntryProgressReview': 'Progress review previous path: Getting to Know You',

    'currentAccountsQuestionGroup': 'Tell us about your accounts you currently have:',
    'currentAccountsQuestionGroup.subtext': 'Add accounts that you currently have setup',
    'currentAccountTypes.cardBuilder.modal.title': 'Select an account type:',
    'currentAccountTypes.cardBuilder.addCard': 'Add Account',
    'currentAccountTypes.cardBuilder.removeCard': 'Remove',
    'currentAccountTypes.cardBuilder.editCard': 'Edit',
    'currentAccountTypes.cardBuilder.cancelEdit': 'Cancel',
    'currentAccountTypes.cardBuilder.saveCard': 'Save',
    'currentAccountTypes': 'Select an account:',
    'currentAccountTypes.checking': 'Checking',
    'currentAccountTypes.savings': 'Savings',
    'currentAccountTypes.mortgageLoan': 'Mortgage Loan',
    'currentAccountTypes.equityLoan': 'Home Equity',
    'currentAccountTypes.otherLoan': 'Other Loans',
    'currentAccountTypes.creditAccounts': 'Credit Card',

    'checking.cardBuilder.title': 'Tell us about your checking account(s):',
    'checkingBalance': currentAccount_amount,
    'details.checkingBalance': `Current checking account | ${ currentAccount_amount }`,
    'checkingBalanceOtherBank': currentAccount_otherBankAmount,
    'details.checkingBalanceOtherBank': `Current checking account | ${ currentAccount_otherBankAmount }`,
    'currentAccount_checkingOtherBankName': currentAccount_otherBankName,
    'details.currentAccount_checkingOtherBankName': `Current checking account | ${ currentAccount_otherBankName }`,
    'checkingBalance.cardBuilder.answerLabel': amount,
    'checkingBalanceOtherBank.cardBuilder.answerLabel': amountOther,
    'currentAccount_checkingOtherBankName.cardBuilder.answerLabel': bankOther,

    'savings.cardBuilder.title': 'Tell us about your savings account(s):',
    'savingsBalance': currentAccount_amount,
    'details.savingsBalance': `Current savings account | ${ currentAccount_amount }`,
    'savingsBalanceOtherBank': currentAccount_otherBankAmount,
    'details.savingsBalanceOtherBank': `Current savings account | ${ currentAccount_otherBankAmount }`,
    'currentAccount_savingsOtherBankName': currentAccount_otherBankName,
    'details.currentAccount_savingsOtherBankName': `Current savings account | ${ currentAccount_otherBankName }`,
    'savingsBalance.cardBuilder.answerLabel': amount,
    'savingsBalanceOtherBank.cardBuilder.answerLabel': amountOther,
    'currentAccount_savingsOtherBankName.cardBuilder.answerLabel': bankOther,

    'mortgageLoan.cardBuilder.title': 'Tell us about your mortgage loan:',
    'homeValue': 'Home value:',
    'homeValue.cardBuilder.answerLabel': 'Value:',
    'details.homeValue': 'Home value:',
    'mortgageLoanBalance': 'Remaining loan balance:',
    'mortgageLoanBalance.cardBuilder.answerLabel': 'Balance:',
    'details.mortgageLoanBalance': 'Loan balance:',

    'equityLoan.cardBuilder.title': 'Tell us about your other equity loan(s):',
    'equityLoanBalance': 'Total balance of your current home equity loan(s):',
    'equityLoanBalance.cardBuilder.answerLabel': 'Types:',
    'equityLoanRate': 'Highest interest rate (%):',
    'equityLoanRate.cardBuilder.answerLabel': 'Rate:',

    'otherLoan.cardBuilder.title': 'Tell us about your other loan(s):',
    'otherLoanTypes': 'What other types of loans do you have:',
    'otherLoanTypes.cardBuilder.answerLabel': 'Types:',
    'otherLoanBalance': 'Total balance of other loan(s):',
    'otherLoanBalance.cardBuilder.answerLabel': 'Balance:',

    'creditAccounts.cardBuilder.title': 'Tell us about your other credit card account(s):',
    'totalCreditAccounts': 'Number of credit card account(s):',
    'totalCreditAccounts.cardBuilder.answerLabel': 'Accounts:',
    'creditAccountsBalance': 'Total balance:',
    'creditAccountsBalance.cardBuilder.answerLabel': 'Balance:',
    'creditAccountsRate': 'Highest interest rate (%):',
    'creditAccountsRate.cardBuilder.answerLabel': 'Rate:',

    'bankingHabitsQuestionGroup': 'Tell us a bit about your banking habits:',
    'atmUsage': 'How many times do you use the ATM each month?',
    'debitUsage': 'How often do you use your debit card monthly?',
    'totalUsage': 'Total monthly usage:',

    'savingHabitsQuestionGroup': 'Tell us a bit about your saving habits:',
    'savingsDepositFrequency': 'How frequently do / will you put money into your savings account?',
    'savingsWithdrawalFrequency': 'How frequently do you withdraw money from your savings account?',

    'reviewBankingProgressReview': 'Progress review previous path: Your Money and Habits',

    'useHomeEquity': 'You have done a great job of building equity in your home!  Would you like to use your equity as collateral for your borrowing goals?',
    'useHomeEquity.vehicleGoal': 'Vehicle',
    'useHomeEquity.debtConsolidationGoal': 'Consolidate Debt',
    'useHomeEquity.educationGoal': 'Education',
    'useHomeEquity.healthcareGoal': 'Healthcare',
    'useHomeEquity.homeGoal': 'Buy a home',
    'useHomeEquity.homeImprovementGoal': 'Home improvement',
    'useHomeEquity.refinanceHomeGoal': 'Refinance home',
    'useHomeEquity.secondHomeGoal': 'Buy a second home / investment property',
    'useHomeEquity.retirementGoal': 'Retirement / Estate planning',
    'useHomeEquity.majorPurchaseGoal': 'Major purchase',
    'useHomeEquity.lifeEventGoal': 'Major life event',
    'useHomeEquity.rainyDayGoal': 'Rainy day',
    'useHomeEquity.otherGoal': 'Other',
    'useHomeEquity.none': 'No, thank you',

    'homeEquityAmountTotal': 'Home Equity Available: ',
    'homeEquityAmountToBorrow': 'Selected Equity Amount: ',

    'collateralType': 'Are you interested in using any of the following to help secure a loan for your borrowing goals?',
    'collateralType.cd': 'CD',
    'collateralType.savings': 'Savings Account',
    'collateralType.none': 'No, thank you',

    'creditCardUsage': 'We offer credit cards to help you build and maintain your credit. Are you interested in any of the following credit card options:',
    'creditCardUsage.low': "I don't have any credit experience, but would like a credit card",
    'creditCardUsage.medium': 'I am looking to rebuild my credit and would like a credit card',
    'creditCardUsage.high': 'I have good credit and would like a credit card',
    'creditCardUsage.no': 'No, I am not interested in a credit card',

    'serviceOffersQuestionGroup': 'We have other services, are you interested in any of the following:',
    'wantsDepositBox': 'Would you like a safe deposit box to store important documents and valuables?',
    'wantsDepositBox.true': yes,
    'wantsDepositBox.false': no,
    'wantsLifeInsurance': 'Do you have plans in place to help with protection and / or unexpected events?',
    'wantsLifeInsurance.whole': 'Whole life insurance',
    'wantsLifeInsurance.term': 'Term life insurance',
    'wantsLifeInsurance.group': 'Group life insurance',
    'wantsLifeInsurance.rainyDay': 'Rainy Day savings',
    'wantsLifeInsurance.none': 'Not right now',

    'licensedBanker': 'Are being assisted by a licensed banker today?',
    'licensedBanker.true': yes,
    'licensedBanker.false': no,

    'postalCode': 'Enter your zip code:',

    /**
     * ============================
     * PRODUCT MESSAGES
     * ============================
     */
    '1000.name': 'Ignite Checking Account',
    '1000.url': 'https://ignitesales.com',
    '1000.description.abbreviated': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vitae mi libero. Integer semper euismod quam a volutpat. Nam elit turpis, facilisis ut arcu ac, euismod consectetur sapien.',
    '1000.description': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi vitae mi libero. Integer semper euismod quam a volutpat. Nam elit turpis, facilisis ut arcu ac, euismod consectetur sapien.',
    '1000.features.count': 3,
    '1000.features.1': 'Feature 1 goes here about the product',
    '1000.features.2': 'It is so exciting to read a second feature',
    '1000.features.3': 'Really...we get 3?!?',
    '1000.disclosures.count': 1,
    '1000.disclosures.1': 'Disclosure information about the products go in this section.',

    '1001.name': 'Ignite Savings',
    '1001.url': 'https://ignitesales.com',
    '1001.description.abbreviated': 'Aenean condimentum felis quis laoreet pretium. Proin a libero et mauris ultricies vestibulum et vitae dolor. Duis vestibulum fermentum euismod. Morbi sit amet quam lacus.',
    '1001.description': 'Aenean condimentum felis quis laoreet pretium. Proin a libero et mauris ultricies vestibulum et vitae dolor. Duis vestibulum fermentum euismod. Morbi sit amet quam lacus.',
    '1001.features.count': 2,
    '1001.features.1': 'Save for your future, starting today, <href>http://ignitesales.com||visit to learn more</href>',
    '1001.features.2': 'Get interest on this account like you\'ve never seen before',
    '1001.disclosures.count': 0


};
